import type { Workbook } from 'exceljs';

/** Lazily loads exceljs and returns a new Workbook. */
export async function createExcelWorkbook(): Promise<Workbook> {
  const { Workbook } = await import('exceljs');
  return new Workbook();
}
